<template>
    <button
        class="button capitalize pointer"
        :class="{
            'button--default': !customClass,
            'button--hover': hasHover
        }"
        v-on="$listeners"
    >
        <slot name="button__icon" />
        <slot name="button__text" />
    </button>
</template>

<script>
export default {
    props: {
        hasHover: {
            type: Boolean,
            default: true
        },
        customClass: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Variables
    // =============================================================================
    $color-classes:
        $color-blue '.background--blue',
        $color-grey '.background--transparent';

    // =============================================================================
    // Style
    // =============================================================================
    .button {
        text-align: center;
        @include transition( all .2s ease-in-out );
        &--default {
            @include dimensions( 100%, 50px );
            @include rounded-corner( 5px );
        }
        &--hover {
            &:hover {
                @include transform( translateY( -2px ) );
                @each $color, $class in $color-classes {
                    &#{$class} {
                        @include box-shadow( 0 4px 20px -2px  rgba( $color, .5 ) );
                    }
                }
            }
            &:active {
                @include transform( translateY( 0 ) );
            }
        }
    }
</style>